import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row constrain items-center q-py-sm full-height" }
const _hoisted_2 = { class: "col-3 q-px-xs flex items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "col-6 flex justify-center q-px-xs" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "col-3 q-px-xs flex items-center justify-end" }

import { watch, computed, ref, onMounted } from 'vue';
  import { Dialog, useQuasar } from 'quasar';
  import { useRoute, useRouter } from 'vue-router';

  import { useAuthStore } from 'src/stores/auth-store';
  import { useProposalStore } from 'src/stores/proposal-store';
  import { useSettingsStore } from 'src/stores/settings-store';

  import AppCreateButton from "src/components/form/buttons/AppCreateButton.vue";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  emits: ['toggleDrawer'],
  setup(__props, { emit: __emit }) {

  const q = useQuasar();
  const route = useRoute();
  const router = useRouter();
  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();
  const proposalStore = useProposalStore();

  // Dark Mode
  const isDark = computed(() => settingsStore.isDark);
  function setDark(isDark: boolean) {
    settingsStore.updateIsDark(isDark);
    q.dark.set(isDark);
  };
  setDark(isDark.value);
  watch(isDark, (nVal: boolean, oVal: boolean) => {
    setDark(nVal);
  });

  const emit = __emit
  function toggleDrawer() {
    emit('toggleDrawer');
  }

  function setReveal(val: boolean) {
    settingsStore.updateIsHeaderRevealed(val);
  }

  function goHome() {
    router.push({ path: "/" })
  }

  onMounted(() => {
    settingsStore.updateBrand(settingsStore.brand);
  })

  const title = computed(() => {
    if (route.meta.headerTitle) {
      return route.meta.headerTitle;
    }

    if (route.name === "Customer") {
      const p = proposalStore.applications.find(p => p.brokerReference === Number(route.params.id))
      if (!p) {
        return "Customer"
      }
      return p.customer ? p.customer.firstName + " " + p.customer.lastName : 'Proposal'
    }

    if (route.name === "Quote") {
      return "Quote"
    }
  })

  const rightAction = computed(() => {
    switch (route.name) {
      case "Customers":
        return {
          icon: "o_add",
          handler: addNew,
          tooltipText: "New Proposal"
        }
      case "Customer":
      case "NewProposal":
      case "QuickQuote":
      case "ViewQuickQuote":
      case "BudgetCalculator":
      case "Settings":
        return {
          icon: "mdi-chevron-left",
          handler: goBack,
          tooltipText: "Back"
        }
      case "Quotes":
        return {
          icon: "o_add",
          handler: addQuote,
          tooltipText: "Quick Quote"
        }
      default:
        return null;
    }
  })

  const showDialog = ref(false);
  function addNew() {
    showDialog.value = true;
  }
  function addProposal() {
    router.push({ name: "NewProposal" })
  }

  function addQuote() {
    router.push({ name: "QuickQuote" })
  }

  function goBack() {
    
    router.go(-1);
    proposalStore.selectApplication(null);
  }

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authStore).isAuthenticated)
      ? (_openBlock(), _createBlock(_component_q_header, {
          key: 0,
          reveal: "",
          onReveal: setReveal,
          style: {"height":"60px"},
          class: "bg-accent"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (rightAction.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_q_btn, {
                        round: "",
                        flat: "",
                        dense: "",
                        class: "q-ml-sm",
                        onClick: rightAction.value.handler
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: rightAction.value.icon,
                            size: "sm"
                          }, null, 8, ["name"]),
                          (rightAction.value.tooltipText)
                            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(rightAction.value.tooltipText), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  innerHTML: title.value,
                  class: "text-center"
                }, null, 8, _hoisted_5),
                _cache[1] || (_cache[1] = _createElementVNode("span", {
                  id: "headerTitle",
                  class: "text-center"
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    round: "",
                    flat: "",
                    dense: "",
                    class: "q-mr-sm",
                    onClick: toggleDrawer
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "mdi-menu",
                        size: "sm"
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          bordered: "",
          class: "q-pa-md"
        }, {
          default: _withCtx(() => [
            _createVNode(AppCreateButton, {
              compact: false,
              vertical: ""
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})